import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

type ParamsType = {
  roomId: string
}

class FetchPchomeProductDataApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_PCHOME_PRODUCT_DATA'

    const { roomId } = params

    this.config = {
      url: `/v1/product/pchome/room/${roomId}`,
      method: 'GET',
    }
  }
}

export const fetchPchomeProductData = (params: ParamsType) => getCallApiFunction(new FetchPchomeProductDataApi(params))
